import {
  AndonBoardLayoutItem,
  AndonDisplayLine
} from "~/features/andon/andon.types";
import {
  isTextLayoutItem,
  isWorkstationLayoutItem
} from "~/features/andon/andon.utils";
import { WorkstationSummaryDto } from "~/types/api";

import AndonBoardTextLabel from "./AndonBoardTextLabel";
import AndonBoardWorkstationCell from "./AndonBoardWorkstationCell";

type AndonBoardElementProps = {
  boardLayoutItem: AndonBoardLayoutItem;
  fontSize: string;
  boardScale?: number;
  iconScale?: number;
  displayLines?: AndonDisplayLine[];
  fcAbbreviation?: string;
  workstation?: WorkstationSummaryDto;
  workstationsReady?: boolean;
  onRemoveWorkstation?: () => void;
};

export function AndonBoardElement({
  boardLayoutItem,
  fontSize,
  boardScale = 1,
  iconScale,
  displayLines,
  fcAbbreviation,
  workstation,
  workstationsReady,
  onRemoveWorkstation
}: AndonBoardElementProps) {
  if (isTextLayoutItem(boardLayoutItem)) {
    return (
      <AndonBoardTextLabel
        textLayoutItem={boardLayoutItem}
        boardScale={boardScale}
      />
    );
  }

  if (isWorkstationLayoutItem(boardLayoutItem)) {
    return (
      <AndonBoardWorkstationCell
        workstationId={boardLayoutItem.i}
        workstation={workstation}
        workstationsReady={workstationsReady}
        fontSize={fontSize}
        iconScale={iconScale}
        displayLines={displayLines}
        fcAbbreviation={fcAbbreviation}
        onRemove={onRemoveWorkstation}
      />
    );
  }

  return null;
}

export default AndonBoardElement;
